import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  margin-bottom: ${p => p.marginBottom || 0};

  white-space: nowrap;

  text-align: center;

  line-height: 1;
  font-weight: ${p => p.isBold ? p.theme.fontWeightBold : p.theme.fontWeightSemibold};

  color: ${p => p.isLabel ? p.theme.colorLabel : p.theme.colorText};

  ${p => p.size === "sm" && "font-size: 0.635rem"};
  ${p => p.size === "md" && "font-size: 0.75rem"};
  ${p => p.size === "lg" && "font-size: 0.925rem"};
  ${p => p.size === "xl" && "font-size: 1.625rem"};

  @media (min-width: ${props => props.theme.screenWidthXxs}) {
    text-align: ${p => p.textAlign || "left"};

    ${p => p.size === "sm" && "font-size: 0.635rem"};
    ${p => p.size === "md" && "font-size: 0.675rem"};
    ${p => p.size === "lg" && "font-size: 0.75rem"};
    ${p => p.size === "xl" && "font-size: 1.25rem"};
  }
`;

const Wrapper = ({
  className,
  children,
  marginBottom,
  size,
  isBold,
  isLabel,
  textAlign
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: className,
    marginBottom: marginBottom,
    size: size,
    isBold: isBold,
    isLabel: isLabel,
    textAlign: textAlign
  }, children);
};

export default Wrapper;